import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  Link,
  Menu,
  MenuItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import { OpenInNew as NewTabIcon } from '@material-ui/icons';

import useAuth from 'src/hooks/useAuth';
import { common, errorMessages } from 'src/assets/locale';

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  externalLink: {
    fontSize: '1em',
    marginLeft: '0.2em'
  },
  popover: {
    width: 200
  }
}));

const myPageUrl = 'https://minside.trimpoeng.no/';

const openMyPage = (e) => {
  e.preventDefault();

  let accessToken = null;
  try {
    accessToken = localStorage.getItem('accessToken');
  } catch (error) {
    console.log(error);
  }

  let url;
  if (accessToken) {
    const params = new URLSearchParams({ accessToken });
    url = `${myPageUrl}?${params.toString()}`;
  } else {
    url = myPageUrl;
  }

  window.open(url, 'myPageBrowserContext');
}

const Account = () => {
  const classes = useStyles();
  const history = useHistory();
  const ref = useRef(null);
  const { user, logout } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const avatarUrl =
    user && user.profileImage && user.profileImage.image
      ? user.profileImage.image.thumbnail
      : null;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await logout();
      history.push('/');
    } catch (err) {
      console.error(err);
      enqueueSnackbar(errorMessages.logOutError, {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
        aria-label={common.account}
      >
        <Avatar alt="" className={classes.avatar} src={avatarUrl} />
        <Hidden smDown>
          <Typography variant="h6" color="inherit">
            {user.firstName}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem
          color="inherit"
          component={Link}
          onClick={(e) => {
            handleClose();
            openMyPage(e);
          }}
          href={myPageUrl}
          target="_blank"
        >
          {common.myPage}
          <NewTabIcon
            className={classes.externalLink}
            titleAccess={common.openInNewTab}
          />
        </MenuItem>
        <MenuItem onClick={handleLogout}>{common.logout}</MenuItem>
      </Menu>
    </>
  );
};

export default Account;
